module.exports = __webpack_public_path__ + "static/clothing-tshirt-2bd34addc94cf6d762070a944d982cc2.jpg";